import { render } from "./ProjectTestMode.vue?vue&type=template&id=3bf5947b"
import script from "./ProjectTestMode.vue?vue&type=script&lang=js"
export * from "./ProjectTestMode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__